<template>
  <div class="cortex-rag">
    <div class="cortex-rag__header" @click="toggle">
      <i class="fas fa-book mr-1"></i>
      <span>{{ $t('kortex.sources') }} ({{ sources.length }})</span>
      <i :class="['ml-auto', expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down']"></i>
    </div>
    <div v-if="expanded" class="cortex-rag__list">
      <div v-for="(source, idx) in sources" :key="idx" class="cortex-rag__item">
        <div class="cortex-rag__item-header">
          <i class="fas fa-file-alt mr-1"></i>
          <span class="cortex-rag__doc-name">{{ source.document_name }}</span>
          <span class="cortex-rag__score ml-auto">{{ formatScore(source.score) }}</span>
        </div>
        <p class="cortex-rag__excerpt">{{ truncate(source.content, 160) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RagSourceCard',
  props: {
    sources: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      expanded: false
    }
  },
  methods: {
    toggle: function () {
      this.expanded = !this.expanded
    },
    formatScore: function (score) {
      if (score === undefined || score === null) return ''
      return (score * 100).toFixed(0) + '%'
    },
    truncate: function (text, length) {
      if (!text) return ''
      if (text.length <= length) return text
      return text.slice(0, length) + '...'
    }
  }
}
</script>

<style scoped lang="scss">
.cortex-rag {
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  margin-top: 12px;
  font-size: 13px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
}

.cortex-rag__header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.45);
  user-select: none;
  font-size: 12px;
  transition: background 0.12s;

  &:hover {
    background: rgba(255, 255, 255, 0.07);
  }
}

.cortex-rag__list {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.cortex-rag__item {
  padding: 10px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);

  &:last-child {
    border-bottom: none;
  }
}

.cortex-rag__item-header {
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  i {
    color: rgba(255, 255, 255, 0.25);
  }
}

.cortex-rag__doc-name {
  font-weight: 600;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.cortex-rag__score {
  font-size: 11px;
  background: rgba(108, 128, 255, 0.12);
  color: rgba(148, 168, 255, 0.85);
  padding: 1px 7px;
  border-radius: 10px;
}

.cortex-rag__excerpt {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.35);
  line-height: 1.5;
}
</style>
